import { FETCH_CHART, FETCH_CHART_SUCCESS, FETCH_CHART_FAILURE } from '../actions';

const initialState = {
 formchart: [],
  loading: true,
  err: null,
  haveData: false
};

export const reducer = (state = initialState, action) => {
  switch(action.type) {
    case FETCH_CHART:
      return {
        ...state,
        loading: true,
        err: null,
        haveData: false
      };
    case FETCH_CHART_SUCCESS:
      return {
        ...state,
        loading: false,   
        haveData: true,     
        formchart: action.data
      };
    case FETCH_CHART_FAILURE:
      return {
        ...state,
        loading: false,
        haveData: false,
        err: action.error,
        formchart: []
      };
    default:
      return state;
  }
}